import {
  RawRepair,
  RepairRow,
  ServiceStatus,
  StatusDisplay,
} from './repairs.types';

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export const SERVICE_STATUS_DISPLAY: Record<number, StatusDisplay> = {
  [ServiceStatus.None]: { label: 'بدون اقدام', tag: '' },
  [ServiceStatus.Inspection]: { label: 'بازدید شده', tag: 'warn' },
  [ServiceStatus.Repair]: { label: 'تعمیر شده', tag: 'ok' },
  [ServiceStatus.Replacement]: { label: 'تعویض شده', tag: 'bad' },
};

const DIGIT_MAP: Record<string, string> = {
  ...Object.fromEntries([...'۰۱۲۳۴۵۶۷۸۹'].map((digit, index) => [digit, String(index)])),
  ...Object.fromEntries([...'٠١٢٣٤٥٦٧٨٩'].map((digit, index) => [digit, String(index)])),
};

export function toEnglishDigits(value: unknown): string {
  return String(value ?? '').replace(/[۰-۹٠-٩]/g, (digit) => DIGIT_MAP[digit]);
}

export function groupDigits(value: unknown): string {
  return (Number(value) || 0).toLocaleString('fa-ir');
}

export function formatWithCommas(value: unknown): string {
  return String(value ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function stripCommas(value: unknown): unknown {
  return typeof value === 'string' ? value.replace(/,/g, '') : value;
}

export function isBlank(value: unknown): boolean {
  return value === null || value === undefined || value === '' || Number(value) === 0;
}

export function parseResponse(data: any): any {
  if (typeof data !== 'string') return data;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

export function toRepairRow(raw: RawRepair): RepairRow {
  const cost = Number(raw.iTotalCost) || 0;

  return {
    ...raw,
    cost,
    costText: groupDigits(cost),
    kmText: groupDigits(raw.iKM),
    searchIndex: [
      raw.strDate,
      raw.strUserSaved,
      raw.strRepairman,
      raw.strReason,
      raw.strComment,
      raw.iKM,
      raw.iTotalCost,
    ].map((value) => toEnglishDigits(value)).join('\n'),
  };
}
